import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var formControlLabelComponentName = 'QuantumFormControlLabel';
export function getFormControlLabelUtilityClass(slot) {
    return generateUtilityClass(formControlLabelComponentName, slot);
}
export var formControlLabelClasses = generateUtilityClasses(formControlLabelComponentName, [
    'root',
    'label',
    'container',
    'labelContainer',
    'controlLabel',
    'decoration',
    'helperText',
]);
